export const TimeZoneAbbreviations = {
  "Africa/Algiers": "WAT",
  "Africa/Cairo": "EET",
  "Africa/Casablanca": "WET",
  "Africa/Harare": "CAT",
  "Africa/Nairobi": "EAT",
  "America/Argentina/Buenos_Aires": "ART",
  "America/Belize": "CST",
  "America/Bogota": "COT",
  "America/Boise": "MST",
  "America/Caracas": "VET",
  "America/Chicago": "CST",
  "America/Chihuahua": "MST",
  "America/Dawson": "PST",
  "America/Detroit": "EST",
  "America/Godthab": "WGT",
  "America/Juneau": "AKST",
  "America/Los_Angeles": "PST",
  "America/Mexico_City": "CST",
  "America/Montevideo": "UYT",
  "America/Phoenix": "MST",
  "America/Regina": "CST",
  "America/Santiago": "CLT",
  "America/Sao_Paulo": "BRT",
  "America/St_Johns": "NST",
  "America/Tijuana": "PST",
  "Asia/Almaty": "ALMT",
  "Asia/Baghdad": "AST",
  "Asia/Baku": "AZT",
  "Asia/Bangkok": "ICT",
  "Asia/Colombo": "IST",
  "Asia/Dhaka": "BST",
  "Asia/Dubai": "GST",
  "Asia/Irkutsk": "IRKT",
  "Asia/Jerusalem": "IST",
  "Asia/Kabul": "AFT",
  "Asia/Kamchatka": "PETT",
  "Asia/Karachi": "PKT",
  "Asia/Kathmandu": "NPT",
  "Asia/Kolkata": "IST",
  "Asia/Krasnoyarsk": "KRAT",
  "Asia/Kuala_Lumpur": "MYT",
  "Asia/Kuwait": "AST",
  "Asia/Magadan": "MAGT",
  "Asia/Rangoon": "MMT",
  "Asia/Seoul": "KST",
  "Asia/Shanghai": "CST",
  "Asia/Taipei": "CST",
  "Asia/Tehran": "IRST",
  "Asia/Tokyo": "JST",
  "Asia/Vladivostok": "VLAT",
  "Asia/Yakutsk": "YAKT",
  "Asia/Yekaterinburg": "YEKT",
  "Atlantic/Azores": "AZOT",
  "Atlantic/Canary": "WET",
  "Atlantic/Cape_Verde": "CVT",
  "Australia/Adelaide": "ACST",
  "Australia/Brisbane": "AEST",
  "Australia/Darwin": "ACST",
  "Australia/Hobart": "AEST",
  "Australia/Perth": "AWST",
  "Australia/Sydney": "AEST",
  "Europe/Amsterdam": "CET",
  "Europe/Athens": "EET",
  "Europe/Belgrade": "CET",
  "Europe/Brussels": "CET",
  "Europe/Bucharest": "EET",
  "Europe/Dublin": "GMT",
  "Europe/Helsinki": "EET",
  "Europe/Lisbon": "WET",
  "Europe/London": "GMT",
  "Europe/Moscow": "MSK",
  "Europe/Sarajevo": "CET",
  GMT: "UTC",
  "Pacific/Auckland": "NZST",
  "Pacific/Fiji": "FJT",
  "Pacific/Guam": "ChST",
  "Pacific/Honolulu": "HST",
  "Pacific/Midway": "SST",
  "Pacific/Tongatapu": "TOT",
  "Canada/Atlantic": "AST",
  "Canada/Pacific": "PST",
  "Canada/Eastern": "EST",
  Poland: "CET",
  "Europe/Bratislava": "CET",
  "Europe/Berlin": "CET",
  "Europe/Zurich": "CET",
  "Europe/Uzhgorod": "EET"
};
